import api from './api';

export const timeTrackingApi = {
  // Start tracking session
  startTracking: (projectId, taskId) =>
    api.post('/time-tracking/start', { project_id: projectId, task_id: taskId }),

  // Update tracking data
  updateTracking: (sessionId, totalSeconds, activeSeconds, idleSeconds) =>
    api.put('/time-tracking/update', {
      session_id: sessionId,
      total_seconds: totalSeconds,
      active_seconds: activeSeconds,
      idle_seconds: idleSeconds
    }),

  // Stop tracking session
  stopTracking: (sessionId) =>
    api.post('/time-tracking/stop', { session_id: sessionId }),

  // Add screenshot
  addScreenshot: (sessionId, screenshotPath) =>
    api.post('/time-tracking/screenshot', {
      session_id: sessionId,
      screenshot_path: screenshotPath
    }),

  // Get tracking sessions
  getTrackingSessions: (params = {}) =>
    api.get('/time-tracking/sessions', { params }),

  // Get daily summary
  getDailySummary: (date) =>
    api.get('/time-tracking/daily-summary', { params: { date } }),

  // Get active session
  getActiveSession: () =>
    api.get('/time-tracking/active-session'),

  // Get today's total time
  getTodayTotalTime: () =>
    api.get('/time-tracking/today-total'),

  // Get sessions by date
  getSessionsByDate: (date) =>
    api.get('/time-tracking/sessions-by-date', { params: { date } }),

  // Admin: Get all employee tracking
  getAllEmployeeTracking: (params = {}) =>
    api.get('/time-tracking/admin/all-employees', { params }),

  // Get idle time statistics
  getIdleStats: (params = {}) =>
    api.get('/time-tracking/idle-stats', { params }),

  // Admin: Get sessions by date for all users
  getAdminSessionsByDate: (date) =>
    api.get('/time-tracking/admin/sessions-by-date', { params: { date } })
};